/**
 * Données factices du menu — ÉDITEUR UNIQUEMENT.
 * Servent au canvas du squelette : le viewer (site publié comme aperçu d'un
 * modèle) génère ses vrais navLinks au runtime (pages + titres H2) et
 * n'importe jamais ce fichier.
 */
export const MOCK_NAV_LINKS = [
  { slug: 'accueil', title: 'Accueil' },
  {
    slug: 'offre',
    title: 'Notre offre',
    children: [
      { slug: 'offre-conseil', title: 'Conseil' },
      { slug: 'offre-integration', title: 'Intégration' },
      { slug: 'offre-support', title: 'Support' },
    ],
  },
  { slug: 'references', title: 'Références' },
  { slug: 'tarifs', title: 'Tarifs' },
  { slug: 'contact', title: 'Contact' },
];
